import { DotLottie } from '@lottiefiles/dotlottie-web';

const initDotLotties = () => {
    const canvases = document.querySelectorAll('.js-dot-lottie');

    if (!canvases.length) {
        return;
    }

    canvases.forEach((canvas) => {
        if (canvas.dataset.dotLottieBound === 'true') {
            return;
        }

        const { dotLottieSrc, dotLottieAutoplay, dotLottieLoop, dotLottieTrigger } = canvas.dataset;

        if (!dotLottieSrc) {
            return;
        }

        canvas.dataset.dotLottieBound = 'true';

        // Dataset values are strings; treat `"false"` as a deliberate opt-out.
        const autoplay = dotLottieAutoplay !== 'false';
        const loop = dotLottieLoop !== 'false';
        const trigger = dotLottieTrigger || 'auto';

        const instance = new DotLottie({
            canvas,
            src: dotLottieSrc,
            autoplay,
            loop,
        });

        if (trigger === 'hover') {
            const host = canvas.closest('[data-dot-lottie-hover-host]') || canvas.closest('a') || canvas;
            const play = () => instance.play();
            const stop = () => instance.stop();

            host.addEventListener('mouseenter', play);
            host.addEventListener('mouseleave', stop);
            host.addEventListener('focus', play);
            host.addEventListener('blur', stop);
        } else if (trigger === 'scroll') {
            const updateFrame = () => {
                const rect = canvas.getBoundingClientRect();
                const windowHeight = window.innerHeight;

                // Calculate progress: 0 when element enters bottom, 1 when it reaches top
                const start = windowHeight;
                const end = -rect.height;
                const current = rect.top;
                const progress = Math.min(1, Math.max(0, (start - current) / (start - end)));

                const totalFrames = instance.totalFrames;
                if (totalFrames > 0) {
                    const frame = Math.floor(progress * (totalFrames - 1));
                    instance.setFrame(frame);
                }
            };

            instance.addEventListener('load', () => {
                window.addEventListener('scroll', updateFrame, { passive: true });
                updateFrame();
            });
        }
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDotLotties);
} else {
    initDotLotties();
}
